import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DEPRECATED_Typography as Typography } from "@jti/ui";
import styles from "./HistoryTableCell.module.scss";
const typographyDefaultProps = {
    type: "small-text",
    weight: "light",
    color: "grey-3",
};
export const HistoryTableCell = ({ isHeader, rowLabel, cellContent }) => {
    if (isHeader)
        return _jsx(Typography, { ...typographyDefaultProps, children: rowLabel });
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { ...typographyDefaultProps, className: styles.mobileLabel, children: rowLabel }), _jsx(Typography, { ...typographyDefaultProps, type: "table-content", children: `${cellContent}` })] }));
};
//# sourceMappingURL=HistoryTableCell.js.map